import { EVENT_STATUS } from '@hedepy/common/enums/EVENT'
import dayjs, { type Dayjs } from 'dayjs'
import React from 'react'

import useEvents from '@/legacy-src/hooks/useEvents'
import { type ServiceType } from '@/legacy-src/types/GeneralStateType'
import { type TherapistType } from '@/legacy-src/types/TherapistStateType'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Heading } from '@/src/domains/design-system/components/Heading'

import { ClientBookingPlannedEvent } from './ClientBookingPlannedEvent'

export interface ClientBookingPlannedEventsProps {
  day: Dayjs
  therapist: TherapistType
  service: ServiceType
}

export const ClientBookingPlannedEvents = ({ day, therapist, service }: ClientBookingPlannedEventsProps) => {
  const { t } = getTranslate()
  const { events: allEvents, isLoading } = useEvents()

  if (isLoading) {
    return null
  }

  const bookedEventForDate = allEvents?.filter(
    (event) =>
      dayjs(event.startDate).isSame(day, 'day') &&
      event.status === EVENT_STATUS.RESERVED &&
      event.serviceId === service.id &&
      event.therapistId === therapist.therapistId,
  )
  const sortedBookedEvents = bookedEventForDate?.sort((a, b) => (dayjs(a.startDate).isBefore(b.startDate) ? -1 : 1))

  if (sortedBookedEvents && sortedBookedEvents.length > 0) {
    return (
      <section className="flex flex-col gap-4">
        <Heading element="h2" variant="xl">
          {t('component.calendar.plannedSessions')}
        </Heading>
        <div className="flex flex-wrap gap-3">
          {sortedBookedEvents.map((event) => (
            <ClientBookingPlannedEvent key={event.id} event={event} />
          ))}
        </div>
      </section>
    )
  }

  return null
}
